export default "/share/@token";
